module.exports = __webpack_public_path__ + "static/media/StepguideSpiderPBSS.8b290b6c.PNG";